import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import CenterTop from '@/components/layout/CenterTop.vue';
import Footer from '@/components/layout/Footer.vue';
import CardInteractive from '@/components/layout/CardInteractive.vue';
import GridLayout from '@/components/layout/GridLayout.vue';
import GridItem from '@/components/layout/GridItem.vue';
import store from '@/store';
import { AUTH_ITEM_CHANGE_CONFIGURATION, AUTH_ITEM_GET, AUTH_ITEM_SAML_GET_AUTH_REQUEST, AUTH_ITEM_SAML_METADATA } from '@/store/actions/authItem';
import Card from '@/components/layout/Card.vue';
import { AuthItemTypeConfiguration } from '@/store/enums/authItemEnum';
import AuthItemsAttributeTable from '@/components/authItem/AuthItemsAttributeTable.vue';
import AuthItemsAttributeMappingTable from '@/components/authItem/AuthItemsAttributeMappingDialog.vue';
import { router } from "@/router";
var SettingsAuthItemSAML2 = /*#__PURE__*/function (_Vue) {
  function SettingsAuthItemSAML2() {
    var _this;
    _classCallCheck(this, SettingsAuthItemSAML2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SettingsAuthItemSAML2, [].concat(args));
    _defineProperty(_this, "breadcrumbItems", []);
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "isMapAttributeModalActive", false);
    _defineProperty(_this, "authItemID", void 0);
    _defineProperty(_this, "name", void 0);
    return _this;
  }
  _inherits(SettingsAuthItemSAML2, _Vue);
  return _createClass(SettingsAuthItemSAML2, [{
    key: "isIDPUpload",
    get: function get() {
      var value = this.getConfFor(AuthItemTypeConfiguration.IDP_METADATA) !== '';
      return value;
    }
  }, {
    key: "urlASC",
    get: function get() {
      var value = this.getConfFor(AuthItemTypeConfiguration.SP_ASC_URL);
      return value + '/login';
    }
  }, {
    key: "spEntityid",
    get: function get() {
      var value = this.getConfFor(AuthItemTypeConfiguration.SP_ENTITY_ID_PROPERTYKEY);
      return value;
    }
  }, {
    key: "isCreateAuthLink",
    get: function get() {
      return store.getters.isAuthLinkCreateAivailable;
    }
  }, {
    key: "isAuthenticationValid",
    get: function get() {
      var value = this.getConfFor(AuthItemTypeConfiguration.SAML_AUTHENTICATION_VALID) === 'true';
      return value;
    }
  }, {
    key: "authItem",
    get: function get() {
      return store.getters.authItem(this.authItemID);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;
      if (!this.isAuthItem) {
        router.push({
          name: 'HomePage'
        });
      }
      this.buildHeaderBreadcrumb();
      this.loading = true;
      store.dispatch(AUTH_ITEM_GET, this.authItemID).then(function (resp) {
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "buildHeaderBreadcrumb",
    value: function buildHeaderBreadcrumb() {
      this.breadcrumbItems = [{
        label: 'Manage authentication',
        isRouterLink: true,
        url: '/authItems'
      }, {
        label: "".concat(this.name, " - ").concat(this.$t('authentications_management.auth_item.edit.saml2.breadcrumb').toString())
      }];
    }
  }, {
    key: "createAuthRequest",
    value: function createAuthRequest() {
      var _this3 = this;
      this.loading = true;
      store.dispatch(AUTH_ITEM_SAML_GET_AUTH_REQUEST, this.authItemID).then(function (resp) {
        _this3.loading = false;
        document.location = resp;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.errorMsg = err;
      });
    }
  }, {
    key: "onFileSelected",
    value: function onFileSelected(fileData) {
      var file = fileData.raw;
      var reader = new FileReader();
      reader.onloadend = this.uploadFile;
      reader.readAsText(file);
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(e) {
      var _this4 = this;
      this.loading = true;
      store.dispatch(AUTH_ITEM_CHANGE_CONFIGURATION, {
        authItemID: this.authItemID,
        type: AuthItemTypeConfiguration.IDP_METADATA,
        value: e.target.result
      }).then(function (resp) {
        _this4.loading = false;
      }).catch(function (err) {
        _this4.loading = false;
        _this4.errorMsg = err;
      });
    }
  }, {
    key: "downloadSPMetadata",
    value: function downloadSPMetadata() {
      var _this5 = this;
      this.loading = true;
      store.dispatch(AUTH_ITEM_SAML_METADATA, this.authItemID).then(function (resp) {
        _this5.loading = false;
        var fileURL = window.URL.createObjectURL(new Blob([resp]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', "sp-".concat(_this5.name, "-metadata.xml"));
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch(function (err) {
        _this5.loading = false;
        _this5.errorMsg = err;
      });
      this.loading = true;
      store.dispatch(AUTH_ITEM_CHANGE_CONFIGURATION, {
        authItemID: this.authItemID,
        type: AuthItemTypeConfiguration.SP_METADATA_DOWNLOADED,
        value: true
      }).then(function () {
        _this5.loading = false;
      }).catch(function (err) {
        _this5.loading = false;
        _this5.errorMsg = err;
      });
    }
  }, {
    key: "downloadIDPMetadata",
    value: function downloadIDPMetadata() {
      var idpMetadata = this.getConfFor(AuthItemTypeConfiguration.IDP_METADATA);
      if (idpMetadata != null) {
        var fileURL = window.URL.createObjectURL(new Blob([idpMetadata]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', "idp-".concat(this.name, "-metadata.xml"));
        document.body.appendChild(fileLink);
        fileLink.click();
      }
    }
  }, {
    key: "getConfFor",
    value: function getConfFor(type) {
      var _iterator = _createForOfIteratorHelper(this.authItem.authItemConfigurations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var authConf = _step.value;
          if (authConf.type === type) {
            return authConf.value;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "isAuthItem",
    get: function get() {
      return store.getters.isAuthItemAvailable;
    }
  }, {
    key: "copyOnClipboard",
    value: function copyOnClipboard(value) {
      navigator.clipboard.writeText(value);
    }
  }, {
    key: "goToAuthLinkCreation",
    value: function goToAuthLinkCreation() {
      router.push('/authLinks');
    }
  }]);
}(Vue);
__decorate([Prop()], SettingsAuthItemSAML2.prototype, "authItemID", void 0);
__decorate([Prop()], SettingsAuthItemSAML2.prototype, "name", void 0);
SettingsAuthItemSAML2 = __decorate([Options({
  components: {
    AuthItemsAttributeMappingTable: AuthItemsAttributeMappingTable,
    AuthItemsAttributeTable: AuthItemsAttributeTable,
    Card: Card,
    GridItem: GridItem,
    GridLayout: GridLayout,
    CardInteractive: CardInteractive,
    Footer: Footer,
    CenterTop: CenterTop,
    MainTitle: MainTitle
  }
})], SettingsAuthItemSAML2);
export default SettingsAuthItemSAML2;